import {
  Component,
  OnInit,
  NgZone,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
  Injectable,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl, FormControl } from '@angular/forms';
import Swal from 'sweetalert2';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { DatePipe } from '@angular/common';
import { environment } from '../../environments/environment';
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { GooglePlaceDirective } from 'node_modules/ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive';
declare const google: any;
declare module 'googlemaps';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
declare var $: any;
import { MapsAPILoader } from '@agm/core';
import { FormService } from '../utils/form.service';
import { BehaviorSubject } from 'rxjs';
import { MessagingService } from '../messaging.service';

@Component({
  selector: 'app-update-profile',
  templateUrl: './update-profile.component.html',
  styleUrls: ['./update-profile.component.css'],
})
export class UpdateProfileComponent implements OnInit {
  currentMessage = new BehaviorSubject(null);

  @ViewChild('addresstext') addresstext: ElementRef;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();

  showSpinner: Boolean = true;
  spinnerType = SPINNER.circle;
  form: FormGroup;
  formBusiness: FormGroup;
  communitySearch: FormGroup;
  addressMain: FormGroup;
  alternateAddress: FormGroup;
  ministrySuggestionForm: FormGroup;
  checkLabel = false;
  search: any;
  affiliatedId: any;
  faithId: any;
  businessIds = [];
  name: any;
  affiliation: any;
  isBusinessContactNameVisible = false;
  isShowStreetAddress: boolean = false;
  isChecked: any;
  @ViewChild('tagInput') tagInputRef: ElementRef;
  tags = [];
  @ViewChild('myModal') modalClose;
  // @ViewChild('placesRef') placesRef: GooglePlaceDirective;
  // public settings: Settings;
  error: string;
  submitted = false;
  isDescription: boolean = false;
  id;
  subscriptionPlanId: string;
  faithList: any = [];
  bussinessList = [];
  communityList: [];
  toppingList = [];
  toppings: any;
  profilePic: any;
  coverPhoto: any;
  bussiness = [];
  custCategories = [];
  loading = false;
  address = {};
  alternateAddresses = [];
  user: any;
  userData: any;
  itemsAsObjects: any;
  comAffModel: NgbModalRef;
  businessModel: NgbModalRef;
  profileModel: NgbModalRef;
  faithModel: NgbModalRef;
  commuinityModel: NgbModalRef;
  addModel: NgbModalRef;
  addressLocation: any;
  hasGoogleSelection: boolean = false;
  addresses: FormArray;
  category: FormArray;
  Sunday: FormArray;
  Monday: FormArray;
  Tuesday: FormArray;
  Wednesday: FormArray;
  Thursday: FormArray;
  Friday: FormArray;
  Saturday: FormArray;
  isAddress: any;
  // public title: any;
  isEmail: any;
  isName: any;
  time = { hour: 13, minute: 30 };
  meridian = true;
  rate;
  lat;
  lng;
  defaultBounds;
  boundsLimit = true;
  options;
  title: string = 'AGM project';
  latitude: number;
  longitude: number;
  zoom: number;
  finish;
  start;
  isMeridian = false;
  readonly = true;
  bhours: any;
  subscriptionPlans: any;
  showDiv: any;
  public valueAndFaith: any;
  private geoCoder;
  user$: any = {};
  isTerms: boolean = true;
  isEdit: boolean = false;
  isTitle: boolean = false;
  descriptionLabel1: any = 'Click to edit field label';
  descriptionLabel: any = '';
  planType: string;
  planName: any;
  selectedPlan: any;
  newBussinessListData: any[];
  selectedFaith: string = '';
  selectedFaith2: string = '';
  selectedFaith3: string = '';
  faithListLevel2: any = [];
  faithListLevel3: any = [];
  skip: number = 0;
  skip1: number = 0;
  limit: number = 1000;
  limit1: number = 1000;
  totalItems1: number = 0;
  ministryAddress: {
    address2: any;
    formatted_address: any;
    location: { type: string; coordinates: any };
    isHidePhone: boolean;
  };
  businessUserName: any;
  checkValidation = false;
  selectedAddress: string = '';
  socialLinksModel: NgbModalRef;

  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngxService: NgxUiLoaderService,
    private zone: NgZone,
    private modalService: NgbModal,
    public router: Router,
    public fb: FormBuilder,
    public authenticationService: AuthenticationService,
    // private datePipe: DatePipe,
    private formService: FormService,
    private messageService: MessagingService
  ) {
    // export const userSubject = new BehaviorSubject<any>(null);
  }

  ngOnInit(): void {
    this.getLocation();
    this.getSubscriptionPlanType();
    this.valueAndFaith = 'We profess Jesus Christ as Lord and conduct our affairs according to Biblical principles, managing our business with integrity and respect.';
    // let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
    this.isEmail = false;
    this.isName = false;
    this.alternateAddresses = [];
    this.user = JSON.parse(localStorage.getItem('merchant_currentUser1'));
    this.planType = localStorage.getItem('planType');
    let info = JSON.parse(localStorage.getItem('merchant_user'));
    this.createCategory();
    this.form = this.fb.group({
      name: [info?.name, [Validators.required]],
      photo: [''],
      coverPhoto: [''],
      userName: ['', [Validators.required]],
      email: [info?.email, [Validators.required, Validators.email]],
      affiliatedBy: ['', [Validators.required]],
      contactNo: ['', [Validators.required]],
      faithName: [''],
      subfaithName: [''],
      subfaith2Name: [''],
      faith: ['', [Validators.required]],
      faith2: [''],
      faith3: [''],
      logLine: ['', []],
      website: ['', [Validators.required]],
      phonecode: ['', []],
      bussinessTypes: [''],
      bussinessHours: ['', []],
      address: ['', [Validators.required]],
      location: ['', []],
      shortBio: ['', [Validators.required, Validators.minLength(6)]],
      address2: ['', []],
      address2Location: [null, []],
      addresses: this.fb.array([]),
      category: this.fb.array([]),
      menu:[''],
      subscriptionPlanType: [''],
      businessUserName: [
        '',
        [
          Validators.required,
          this.noWhitespaceOrSpecialCharacter,
          Validators.minLength(6),
        ],
      ],
      iosAppStoreLink: [''],
      androidAppStoreLink: [''],
      facebookLink: [''],
      instagramLink: [''],
      youtubeLink: [''],
      linkedinLink: [''],
      tiktokLink: [''],
    });
    //Restrict profile user names to no space s
    this.form.get('businessUserName')?.valueChanges.subscribe((value: string) => {
      if (value && value.includes(' ')) {
      this.form.get('businessUserName')?.setValue(value.replace(/\s+/g, ''), { emitEvent: false });
    }});



    this.ministrySuggestionForm = this.formService.affiliation;

    // this.addCategory();

    if (info && info.email) {
      this.isEmail = true;
    }
    if (info && info.name) {
      this.isName = true;
    }
    if (this.user.isFirstUpdateDone == false) {
      this.isTerms = true;
    }
    if (this.user && this.user.isFirstUpdateDone == true) {
      this.getUserProfile();
      this.getFaithList();
      this.title = 'Update Profile';
      this.isTerms = false;
      this.isChecked = true;
    } else {
      this.title = 'Sign Up';
    }

    $('.collapse').collapse();
    // this.titleService.setTitle('Home | @angular-material-extensions/google-maps-autocomplete');
    // this.zoom = 10;
    // this.latitude = 52.520008;
    // this.longitude = 13.404954;createCustomerFormGroup

    // this.setCurrentPosition();
    let location = {};
    this.getFaithList();
    this.businessList('');
    // this.community('')
    this.searchCommunity('');
    this.addressMain = this.fb.group({
      name:[''],
      streetAddress: [''],
      city: [''],
      state: [''],
      googleAddress: [''],
      postalCode: [''],
      country: [''],
      suite_no: [''],
      address_contact_no: [''],
      address_alternateContact_no: [''],
      location: [location, []],
    });
    this.alternateAddress = this.fb.group({
      streetAddress: [''],
      city: [''],
      state: [''],
      googleAddress: [''],
      postalCode: [''],
      country: [''],
      suite_no: [''],
      address_contact_no: [''],
      location: [location, []],
    });
    this.communitySearch = this.fb.group({
      areaCode: ['', []],
      city: ['', []],
      state: ['', []],
      country: ['', []],
      long: ['', []],
      lat: ['', []],
      search: ['', []],
      location: [location, []],
      faithName: ['', []],
      denominiation: ['', []],
      fellowship: ['', []],
      merchant: ['', []],
      bussinessTypes: ['', []],
    });
    this.formBusiness = this.fb.group({
      Sunday: this.fb.array([this.createSunItem()]),
      Monday: this.fb.array([this.createMonItem()]),
      Tuesday: this.fb.array([this.createTueItem()]),
      Wednesday: this.fb.array([this.createWedItem()]),
      Thursday: this.fb.array([this.createThurItem()]),
      Friday: this.fb.array([this.createFriItem()]),
      Saturday: this.fb.array([this.createSatItem()]),
    });
  }

  inputValue(event: any) {
    this.descriptionLabel = event;
  }

  openSuggestMinistry(content: any) {
    this.modalService.dismissAll();
    this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  invokeEvent(place: Object) {
    this.setAddress.emit(place);
  }

  // filter google address and patch values for next job address form
  getGoogleAddress(event: any) {
    // let addressData: any = [];
    this.ministrySuggestionForm.get('address')?.setValue(event.address);

    // if (address) {
    //   console.log('place', address);

    //   address.address_components.find((data: any) => {
    //     if (data.types.includes('postal_code')) {
    //       addressData.zipCode = data.long_name;
    //     }
    //     if (data.types.includes('country')) {
    //       addressData.country = data.long_name;
    //     }
    //     if (data.types.includes('administrative_area_level_1')) {
    //       addressData.state = data.long_name;
    //     }
    //     if (data.types.includes('locality')) {
    //       addressData.city = data.long_name;
    //     }
    //   });

    //   addressData.formattedAddress = address.formatted_address;
    //   addressData.name = address.name;
    //   let arr = address?.formatted_address?.split(',');
    //   this.invokeEvent(address);
    //   let lat = address?.geometry?.location.lat();
    //   let lng = address?.geometry?.location.lng();
    //   addressData.coordinate = [lat, lng];

    //   let addressValue = {
    //     address2: addressData.name ? addressData.name : '',
    //     city: addressData.city ? addressData.city : '',
    //     state: addressData.state ? addressData.state : '',
    //     postalCode: addressData.zipCode ? addressData.zipCode : '',
    //     country: addressData.country ? addressData.country : '',
    //     location: {
    //       type: 'Point',
    //       coordinates: addressData.coordinate ? addressData.coordinate : '',
    //     },
    //     isHidePhone: false,
    //   };

    //   this.ministryAddress = addressValue;
    // }

    // return addressData;
  }

  onMinistrySubmit() {
    this.submitted = true;
    let data = {
      name: this.ministrySuggestionForm.value.name
        ? this.ministrySuggestionForm.value.name
        : '',
      email: this.ministrySuggestionForm.value.email
        ? this.ministrySuggestionForm.value.email
        : '',
      address: this.ministryAddress ? this.ministryAddress : {},
      phone: this.ministrySuggestionForm.value.phone
        ? this.ministrySuggestionForm.value.phone
        : '',
      website: this.ministrySuggestionForm.value.companyWebsite
        ? this.ministrySuggestionForm.value.companyWebsite
        : '',
    };

    this.authenticationService
      .postData('/user/createCommunity', data)
      .subscribe(
        (result: any) => {
          try {
            if (result.code === 200) {
              Swal.fire('successfully', 'Save Data', 'success');
              this.modalService.dismissAll();
              this.ministrySuggestionForm.reset();
              this.affiliatedId = result?.data?._id;
              this.form.controls['affiliatedBy'].setValue(result?.data?.name);
              let affiliationResult = JSON.stringify(result?.data);
              localStorage.setItem('affiliationData', affiliationResult);
            }
          } catch (error: any) {
            console.log('errorr', error.error);
            Swal.fire('Invalid', `${result.message}`, 'error');
          }
        },
        (error: any) => {
          console.log('erroror', error.error.error);
          Swal.fire();
        }
      );
  }

  //   ngAfterViewInit(){
  //     if (this.user.isFirstUpdateDone == true) {
  //       this.getUserProfile();
  //     }
  //  }

  noWhitespaceOrSpecialCharacter(control) {
    if (
      control.value &&
      (control.value.trim() !== control.value ||
        !/^[a-zA-Z0-9]*$/.test(control.value))
    ) {
      return { whitespaceOrSpecialCharacter: true };
    }
    return null;
  }

  getAddress(place: object) {
    this.address = place['formatted_address'];
    // this.phone = this.getPhone(place);
    // this.formattedAddress = place['formatted_address'];
    // this.zone.run(() => this.formattedAddress = place['formatted_address']);
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (position) {
            this.defaultBounds = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
          }
        },
        (error) => console.log(error)
      );
    } else {
      alert('Geolocation is not supported by this browser.');
    }
  }

  limitCheckbox(e) {
    if (e.target.checked) {
      this.boundsLimit = true;
    } else if (!e.target.checked) {
      this.boundsLimit = false;
    }
  }

  removeTag(tag): void {
    this.businessIds.splice(tag, 1);
    if (this.businessIds.length == 0) {
      this.form.controls['bussinessTypes'].setValue('');
    } else {
      this.form.controls['bussinessTypes'].setValue(
        this.businessIds[0].tagName
      );
    }
  }
  onKeyUp(event: KeyboardEvent): void {
    const inputValue: string = this.form.controls.tag.value;
    if (event.code === 'Backspace' && !inputValue) {
      // this.removeTag();
      return;
    } else {
      if (event.code === 'Comma' || event.code === 'Space') {
        // this.addTag(inputValue);
        this.form.controls.tag.setValue('');
      }
    }
  }
  createSunItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createMonItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createTueItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createWedItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createThurItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createFriItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createSatItem() {
    return this.fb.group({
      Start: [''],
      Finish: [''],
    });
  }
  createItem() {
    return this.fb.group({
      streetAddress: [''],
      city: [''],
      location: [''],
      state: [''],
      googleAddress: [''],
      postalCode: [''],
      country: [''],
      suite_no: [''],
      address_contact_no: [''],
      address_alternateContact_no: [''],
    });
  }
  createCategory() {
    return this.fb.group({
      title: ['', Validators.required],
      description: ['', [Validators.required]],
    });
  }
  public startTime: any;
  public endTime: any;

  getBusinessHours(day) {
    let bdata = this.authenticationService.BusinessData(day);
    this.bhours = bdata;
  }
  addSunItem() {
    this.Sunday = this.formBusiness.get('Sunday') as FormArray;
    this.Sunday.push(this.createSunItem());
    // this.getBusinessHours(this.Sunday)
  }

  addMonItem() {
    this.Monday = this.formBusiness.get('Monday') as FormArray;
    this.Monday.push(this.createMonItem());
    // this.getBusinessHours(this.Monday)
  }
  addTuesItem() {
    this.Tuesday = this.formBusiness.get('Tuesday') as FormArray;
    this.Tuesday.push(this.createTueItem());
    // this.getBusinessHours(this.Tuesday)
  }
  addWedItem() {
    this.Wednesday = this.formBusiness.get('Wednesday') as FormArray;
    this.Wednesday.push(this.createTueItem());
    // this.getBusinessHours(this.Wednesday)
  }

  addThursItem() {
    this.Thursday = this.formBusiness.get('Thursday') as FormArray;
    this.Thursday.push(this.createThurItem());
    // this.getBusinessHours(this.Thursday)
  }
  addFriItem() {
    this.Friday = this.formBusiness.get('Friday') as FormArray;
    this.Friday.push(this.createFriItem());
    // this.getBusinessHours(this.Friday)
  }

  get categoryControls() {
    return (this.form.get('category') as FormArray).controls;
  }
  addSatItem() {
    this.Saturday = this.formBusiness.get('Saturday') as FormArray;
    this.Saturday.push(this.createSatItem());
    // this.getBusinessHours(this.Saturday)
  }
  addItem() {
    this.addresses = this.form.get('addresses') as FormArray;
    this.addresses.push(this.createItem());
  }

  addCategory() {
    this.category = this.form.get('category') as FormArray;
    if (this.category.value.length >= 1) this.checkLabel = true;
    if (this.category.value.length <= 2) {
      this.showDiv = false;
      this.category.push(this.createCategory());
    }
    // this.category.reset();
  }

  addSubCategory(index: number) {
    this.category = this.form.get('category') as FormArray;

    if (index === 0) {
      if (this.category.length < 2) {
        this.category.push(this.createCategory());
      }
    } else if (index === 1) {
      if (this.category.length < 2) {
        this.category.push(this.createCategory());
      }
    }
  }

  removeBusinessHour(index, type) {
    if (type == 'Sunday') {
      this.Sunday = this.formBusiness.get('Sunday') as FormArray;
      this.Sunday.removeAt(index);
    } else if (type == 'Monday') {
      this.Monday = this.formBusiness.get('Monday') as FormArray;
      this.Monday.removeAt(index);
    } else if (type == 'Tuesday') {
      this.Tuesday = this.formBusiness.get('Tuesday') as FormArray;
      this.Tuesday.removeAt(index);
    } else if (type == 'Wednesday') {
      this.Wednesday = this.formBusiness.get('Wednesday') as FormArray;
      this.Wednesday.removeAt(index);
    } else if (type == 'Thursday') {
      this.Thursday = this.formBusiness.get('Thursday') as FormArray;
      this.Thursday.removeAt(index);
    } else if (type == 'Friday') {
      this.Friday = this.formBusiness.get('Friday') as FormArray;
      this.Friday.removeAt(index);
    } else if (type == 'Friday') {
      this.Friday = this.formBusiness.get('Friday') as FormArray;
      this.Friday.removeAt(index);
    } else if (type == 'Saturday') {
      this.Saturday = this.formBusiness.get('Saturday') as FormArray;
      this.Saturday.removeAt(index);
    }
  }

  removeItem(index) {
    this.addresses.removeAt(index);
  }
  removeCategory(index) {
    this.category.removeAt(index);
  }
  onChange(event) {}
  deleteCategory(i) {
    this.custCategories.splice(i, 1);
  }
  get f() {
    return this.form.controls;
  }

  checkedValue(val1, val2) {}
  keyPress(event) {}

  public communityAddress(address: any) {
    console.log('--address', address);
    this.zone.run(() => {
      let address_components = address.address_components;
      for (let i = 0; i < address_components.length; i++) {
        if (address_components[i].types[0] == 'administrative_area_level_2') {
          this.address['city'] = address_components[i].long_name;
        } else if (
          address_components[i].types[0] == 'administrative_area_level_1'
        ) {
          this.address['state'] = address_components[i].long_name;
        } else if (address_components[i].types[0] == 'country') {
          this.address['country'] = address_components[i].long_name;
        }
      }
      this.communitySearch.get('city').setValue([this.address['city']]);
      this.communitySearch.get('state').setValue([this.address['state']]);
      this.communitySearch.get('country').setValue([this.address['country']]);
    });
  }
  public addr = {};

  public AddressChange(address: any) {
    console.log("address?>>>>>>>>>>>>>>>>>>>>", address);
    this.zone.run(() => {
      this.ministrySuggestionForm.controls['name'].setValue(address.name);
      this.addr['streetAddress'] = address.formatted_address;
      this.addr['address_contact_no'] = address.formatted_phone_number;
      this.addr['address_alternateContact_no'] = '';
      this.addr['googleAddress'] = address.name;
      var latitude = address.geometry.location.lat();
      var longitude = address.geometry.location.lng();
      (this.addressLocation = {
        type: 'Point',
        coordinates: [latitude, longitude],
      }),
        (this.addr['location'] = this.addressLocation);
      let address_components = address.address_components;
      for (let i = 0; i < address_components.length; i++) {
        if (address_components[i].types[0] == 'locality') {
          this.addr['city'] = address_components[i].long_name || '';
        } else if (
          address_components[i].types[0] == 'administrative_area_level_1'
        ) {
          this.addr['state'] = address_components[i].long_name || '';
        } else if (address_components[i].types[0] == 'country') {
          this.addr['country'] = address_components[i].long_name || '';
        } else if (address_components[i].types[0] == 'postal_code') {
          this.addr['postalCode'] = address_components[i].long_name || '';
        }
      }
      this.addressMain.controls['googleAddress'].setValue(
        this.addr['googleAddress']
      );
      this.addressMain.controls['city'].setValue(this.addr['city']);
      this.addressMain.controls['state'].setValue(this.addr['state']);
      this.addressMain.controls['streetAddress'].setValue(
        this.addr['streetAddress']
      );
      this.addressMain.controls['postalCode'].setValue(this.addr['postalCode']);
      this.addressMain.controls['country'].setValue(this.addr['country']);
      this.addressMain.controls['address_contact_no'].setValue(
        this.addr['address_contact_no']
      );
      this.addressMain.controls['location'].setValue(this.addressLocation);
      this.hasGoogleSelection = true;
    });
  }

  uploadBanner(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const formData = new FormData();

      formData.append('image', file, file.name);
      formData.append('imageType', 'coverImage');

      this.ngxService.start();
      this.authenticationService.upload(formData).subscribe(
        (data) => {
          this.ngxService.stop();
          this.coverPhoto = data['data'].url;
          this.form.get('coverPhoto').setValue(this.coverPhoto);
        },
        (error) => {
          this.loading = false;
          if (error.status == 401) {
          } else {
            this.error = error.error.message;
            this.ngxService.stop();
            Swal.fire('Error', 'Oops...', error.error.message);
          }
        }
      );
    } else {
      Swal.fire('Error', 'Oops...');
    }
  }

  uploadProfile(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      const formData = new FormData();

      formData.append('image', file, file.name);
      formData.append('imageType', 'profilePic');
      this.ngxService.start();
      this.authenticationService.upload(formData).subscribe(
        (data) => {
          this.ngxService.stop();
          this.profilePic = data['data'].url;
          this.form.get('photo').setValue(this.profilePic);
        },
        (error) => {
          this.loading = false;
          if (error.status == 401) {
          } else {
            this.error = error.error.message;
            this.ngxService.stop();
            Swal.fire('Error', 'Oops...', error.error.message);
          }
        }
      );
    } else {
      Swal.fire('Error', 'Oops...');
    }
  }
  openProfilePrivacy(content) {
    this.profileModel = this.modalService.open(content, {
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
    });
  }
  openBusinessHour(content) {
    this.businessModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }
  openCommunityAffiliation(content) {
    this.address = {};
    this.faithId = '';
    this.comAffModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }
  openFaith(content) {
    this.faithModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  openCommunity(content) {
    this.community('');
    this.commuinityModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  openSocialLinks(content) {
    this.socialLinksModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  saveSocialLinks() {
    // Social links are already bound to form controls via ngModel
    // Just close the modal
    if (this.socialLinksModel) {
      this.socialLinksModel.close();
    }
  }
  selectFaith(id, name) {
    this.faithId = id;
    this.form.controls['faith'].setValue(name);
    this.communitySearch.controls['faithName'].setValue(name);
  }
  selectComunitty(id, name) {
    this.affiliatedId = id;
    this.form.controls['affiliatedBy'].setValue(name);
  }
  openBusiness(content, event) {
    this.businessList('');
    this.getFaithList();
    let value = event.target.value;
    var nameArr = value.split(',');
    this.modalService
      .open(content, {
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          // this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  openAddress(content, type) {
    if (type == 1) {
      this.isAddress = true;
    } else if (type == 2) {
      this.isAddress = false;
      // this.addressMain.reset();
      // Clear any previously added alternate list boxes; we now use a single Address 2 field
      this.alternateAddresses = [];
    }

    // Always reset the address form when opening the modal so stale
    // coordinates from a previous selection can't enable Save.
    // Keep an empty location object to satisfy form shape.
    const emptyLocation: any = { type: 'Point', coordinates: [] };
    this.hasGoogleSelection = false;
    this.addressMain.reset({
      name: '',
      streetAddress: '',
      city: '',
      state: '',
      googleAddress: '',
      postalCode: '',
      country: '',
      suite_no: '',
      address_contact_no: '',
      address_alternateContact_no: '',
      location: emptyLocation,
    });

    this.addModel = this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }
  openAlternateAddress(content) {
    this.modalService.open(content, {
      backdrop: 'static',
      keyboard: false,
    });
  }
  addAddress(value) {
    // Require valid Google selection producing coordinates
    if (!(value?.location?.coordinates && value.location.coordinates.length === 2)) {
      Swal.fire('Error', 'Please use Google location (pick from suggestions).');
      return;
    }
    if (!value.postalCode) {
      Swal.fire('Error', 'Postal code is required');
      return;
    } else if (!value.streetAddress) {
      Swal.fire('Error', 'street Address name is required');
      return;
    } else if (!value.city) {
      Swal.fire('Error', 'City  is required');
      return;
    } else if (!value.state) {
      Swal.fire('Error', 'State name  is required');
      return;
    }
    if (this.isAddress) {
      this.address = value;
      this.form.controls['address'].setValue(value.streetAddress);
      // Persist coordinates to main form for validation on submit
      this.form.controls['location'].setValue(value.location);
      console.log("value,google address: ",value.streetAddress);
      this.addressMain.reset();
    } else {
      // Do not add to list; set Address 2 text and coords only
      this.form.controls['address2'].setValue(value.streetAddress || value.googleAddress || '');
      this.form.controls['address2Location'].setValue(value.location || null);
      this.addressMain.reset();
    }

    this.addModel.close();
  }
  removeAddress(i) {
    this.alternateAddresses.splice(i, 1);
  }

  upload(file: File) {
    const formData = new FormData();
    formData.append('image', this.form.get('profile').value);
    formData.append('imageType', 'profilePic');
    this.authenticationService.upload(formData).subscribe(
      (data) => {
        let image = data['items'];
      },
      (error) => {
        if (error.status == 401) {
        } else {
          this.error = error.error.message;
          this.loading = false;
          Swal.fire('Error', 'Oops...', error.error.message);
        }
      }
    );
  }
  public getFaithList(): void {
    this.ngxService.start();
    this.authenticationService.getFaith().subscribe(
      (data) => {
        this.faithList = [...data['data'], ...this.faithList];
        const x = this.faithList?.find(
          (faith: any) => faith._id === this.selectedFaith
        );
        this.faithListLevel2 = x?.subcategory;
        const y = this.faithListLevel2?.find(
          (subfaith: any) => subfaith._id === this.selectedFaith2
        );
        this.faithListLevel3 = y?.subcategory;
      },
      (error) => {
        if (error.status == 401) {
        } else {
          this.error = error.error.message;
          this.loading = false;
          Swal.fire('Error', 'Oops...', error.error.message);
        }
      }
    );
    this.ngxService.stop();
  }
  checkType(val) {
    val != val;
  }
  filterByTagName(tagName: any) {
    const filteredItems = [];
    this.newBussinessListData.forEach((item) => {
      const matchedTag = item.name.find(
        (tag) => tag.tag.toLowerCase() === tagName.toLowerCase()
      );
      if (matchedTag) {
        filteredItems.push({
          category: item.category,
          _id: item._id,
          name: [matchedTag],
        });
      }
    });
    return filteredItems;
  }
  getFilteredRecord(query: any) {
    const results = [];
    this.newBussinessListData.forEach((item) => {
      const categoryMatch = item.category
        .toLowerCase()
        .includes(query.toLowerCase());
      const tagMatches = item.name.filter((tag) =>
        tag.tag.toLowerCase().includes(query.toLowerCase())
      );
      if (categoryMatch) {
        results.push(item);
      }
      if (!categoryMatch && tagMatches.length > 0) {
        tagMatches.forEach((tag) => {
          let matchedItem = this.filterByTagName(tag.tag);
          console.log(matchedItem, 'matchedItem');
          results.push(matchedItem);
        });
      }
    });
    return results;
  }
  public businessList(search: any): void {
    this.authenticationService.getBusinessType(search).subscribe(
      (data) => {
        this.bussinessList = data['items'];
        // Sort categories alphabetically
        this.bussinessList.sort((a, b) => a.category.localeCompare(b.category));

        // Sort tags alphabetically within each category
        this.bussinessList.forEach((item) => {
          item.name.sort((a, b) => a.tag.localeCompare(b.tag));
        });
        this.newBussinessListData = this.bussinessList;
      },
      (error) => {
        if (error.status == 401) {
        } else {
          this.error = error.error.message;
          this.loading = false;
          Swal.fire('Error', 'Oops...', error.error.message);
        }
      }
    );
    this.ngxService.stop();
  }

  public createBusinessHours(value): void {
    this.getBusinessHours(value);
    let bHours = {};
    if (
      value.Sunday[0].Start == '' &&
      value.Monday[0].Start == '' &&
      value.Tuesday[0].Start == '' &&
      value.Wednesday[0].Start == '' &&
      value.Thursday[0].Start == '' &&
      value.Friday[0].Start == '' &&
      value.Saturday[0].Start == ''
    ) {
      Swal.fire('X', 'Select business hours atleast for one day.');
      return;
    }
    bHours['Sunday'] = value.Sunday;
    bHours['Monday'] = value.Monday;
    bHours['Tuesday'] = value.Tuesday;
    bHours['Wednesday'] = value.Wednesday;
    bHours['Thursday'] = value.Thursday;
    bHours['Friday'] = value.Friday;
    bHours['Saturday'] = value.Saturday;

    this.authenticationService.createBusinessHours(bHours).subscribe(
      (data) => {
        this.communityList = data['items'];
        Swal.fire('', 'Business hours are created sucessfully.', 'success');
        this.businessModel.close();
      },
      (error) => {
        if (error.status == 401) {
        } else {
          this.error = error.error.message;
          this.loading = false;
          Swal.fire('Error', 'Oops...', error.error.message);
        }
        this.businessModel.close();
      }
    );
  }
  public community_affliation(val): void {
    let obj = {};
    obj['limit'] = '100';
    obj['areaCode'] = val.areaCode;
    obj['city'] = val.city && val.city[0] ? val.city[0] : '';
    obj['state'] = val.state && val.state[0] ? val.state[0] : '';
    obj['country'] = val.country && val.country[0] ? val.country[0] : '';
    obj['long'] = val.long;
    obj['skip'] = '0';
    obj['lat'] = val.lat;
    obj['search'] = val.search;
    obj['faith'] = this.faithId;
    obj['denominiation'] = val.denominiation;
    obj['merchant'] = val.merchant;
    obj['bussinessTypes'] = val.bussinessTypes;
    this.authenticationService.getCommunity(obj).subscribe(
      (data) => {
        this.communityList = data['items'];
        this.comAffModel.close();
        this.communitySearch.reset();
      },
      (error) => {
        if (error.status == 401) {
        } else {
          // $("#" + mod).modal("hide");
          this.error = error.error.message;
          this.loading = false;
          Swal.fire('Error', 'Oops...', error.error.message);
        }
        this.comAffModel.close();
      }
    );
  }
  public text: string;
  searchCommunity(value: string): void {
    this.communityList = [];
    this.ngxService.start();
    this.authenticationService
      .getCommunity({
        search: value,
        skip: '0',
        limit: '100',
      })
      .subscribe(
        (data) => {
          this.communityList = data['items'];
          this.ngxService.stop();
        },
        (error) => {
          if (error.status == 401) {
          } else {
            this.error = error.error.message;
            this.loading = false;
            Swal.fire('Error', 'Oops...', error.error.message);
            if (error.error.message == 'Unauthorized') {
              this.authenticationService.logout();
            }
          }
        }
      );
  }
  savePolicy() {
    let obj = { affiliation: this.affiliation };
    if (this.affiliation == 'fellowshipAffiliates') {
      this.affiliation = 'Felloship(/sign-up)';
    }
    this.authenticationService.profilePolicy(obj).subscribe(
      (response: any) => {
        this.affiliation = response.data.affiliation.privacyType;

        this.profileModel.close();
        Swal.fire('Sucess', 'Policy is added sucessfully', 'success');
      },
      (error) => {
        this.profileModel.close();
        if (error.error.message == 'Unauthorized') {
        }
      }
    );
  }
  public community(event: string) {
    let data = {
      skip: 0,
      limit: 10,
      search: '',
    };
    this.ngxService.start();
    this.authenticationService.getCommunities(data).subscribe(
      (data) => {
        this.communityList = data['items'];
      },
      (error) => {
        if (error.status == 401) {
        } else {
          this.error = error.error.message;
          this.loading = false;
          Swal.fire('Error', 'Oops...', error.error.message);
        }
      }
    );
    setTimeout(() => {
      this.ngxService.stop();
    }, 2500);
  }
  selectBusinessType(categoryId, tagId, tagName) {
    const tagExists = this.businessIds.some(tag => tag.tagName === tagName);
    if (tagName) {
      this.bussiness.push(tagName);
      let changeToString = this.bussiness.toString();
      if (!tagExists) {
        this.businessIds.push({
          categoryId: categoryId,
          tagId: tagId,
          tagName: tagName,
        });
      }
      this.form.controls['bussinessTypes'].setValue(
        this.businessIds[0].tagName
      );
    }
    this.form.get('bussinessTypes')?.reset();
  }

  checkBusiness(val) {
    if (val.target.checked) {
      this.isBusinessContactNameVisible = true;
    } else {
      this.isBusinessContactNameVisible = false;
    }
  }

  checkAddress(val: any) {
    if (val.target.checked) {
      this.isShowStreetAddress = true;
    } else {
      this.isShowStreetAddress = false;
    }
  }

  isValidUrl(userInput) {
    var res = userInput.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
    );
    if (res == null) {
      return false;
    } else {
      return true;
    }
  }
  getInputChange(val: any, name: any) {
    const category = this.form.get('category') as FormArray;
    if (name === 'title') {
      const descriptionControl = category.at(1).get('description');
      if (val) {
        descriptionControl?.setValidators([Validators.required]);
      } else {
        descriptionControl?.clearValidators();
      }
      descriptionControl?.updateValueAndValidity();
    }
  }
  // public onSubmit(values: Object): void {
  //   console.log(this.form.value.faithName, 'this.form', this.selectedFaith);
  //   let userObj = {};
  //   this.submitted = true;
  //   // stop here if form is invalid

  //   // if (
  //   //   this.form.invalid ||
  //   //   !this.form?.value?.category[0]?.title ||
  //   //   !this.form?.value?.category[1]?.description
  //   // ) {
  //   //   if (!this.form?.value?.category[0]?.title) {
  //   //     this.showDiv = true;
  //   //     this.isTitle = true;
  //   //   }
  //   //   if (!this.form?.value?.category[1]?.description) {
  //   //     this.showDiv = true;
  //   //     this.isDescription = true;
  //   //   }
  //   //   Swal.fire('Error', 'Please complete required fields.', 'error');
  //   //   return;
  //   // }
  //   if (!this.form?.value?.faithName) {
  //     this.form.controls['faithName'].setValue('');
  //     Swal.fire('Error', 'Faith name is required.', 'error');
  //     return;
  //   }
  //   // if (this.form.valid){
  //   let phonecode = this.form.get('phonecode').value;
  //   let contactNo = this.form.get('contactNo').value;
  //   let isUrl = this.isValidUrl(values['website']);

  //   if (!this.isChecked) {
  //     Swal.fire(
  //       'Error',
  //       'Please select our terms of services and privacy policy to continue.',
  //       'error'
  //     );
  //     return;
  //   }
  //   if (contactNo && !phonecode) {
  //     Swal.fire('Error', 'Phone code is required', 'error');
  //     return;
  //   }

  //   if (this.businessIds.length == 0) {
  //     Swal.fire('Error', 'Business Type is required', 'error');
  //     return;
  //   }
  //   let phoneNumber = phonecode + contactNo;
  //   userObj['photo'] = this.profilePic;
  //   userObj['coverPhoto'] = this.coverPhoto;
  //   userObj['phonecode'] = phonecode;
  //   userObj['contactNo'] = contactNo;
  //   userObj['userName'] = this.form.get('userName').value;
  //   userObj['name'] = this.form.get('name').value;
  //   userObj['affiliatedBy'] = this.affiliatedId;
  //   userObj['faith'] = this.selectedFaith;
  //   userObj['subFaith'] = this.selectedFaith2;
  //   userObj['subFaith2'] = this.selectedFaith3;
  //   userObj['logLine'] = this.form.get('logLine').value;
  //   userObj['bussinessTypes'] = this.businessIds;
  //   userObj['location'] = this.address['location'];
  //   userObj['website'] = this.form.get('website').value;
  //   userObj['address'] = this.address;
  //   userObj['address2'] = this.form.get('address2').value;
  //   userObj['menu'] = this.form.get('menu').value;
  //   userObj['menu'] = this.form.get('menu').value;
  //   userObj['customCategory'] = this.form.get('category').value;
  //   userObj['isBusinessContactNameVisible'] = this.isBusinessContactNameVisible;
  //   userObj['showStreetAddress'] = this.isShowStreetAddress;
  //   userObj['shortBio'] = this.form.get('shortBio').value;
  //   userObj['email'] = this.form.get('email').value;
  //   userObj['subscriptionPlanType'] = this.subscriptionPlanId;
  //   userObj['businessUserName'] = this.form.get('businessUserName').value;
  //   this.ngxService.start();
  //   this.updateProfile(userObj);
  // }

  // Recursively mark all controls as touched and collect names of missing required fields
  private markAndCollectMissingRequired(control: AbstractControl, path: string[] = []): string[] {
    const missing: string[] = [];
    if (control instanceof FormGroup) {
      Object.keys(control.controls).forEach((key) => {
        const child = control.controls[key];
        missing.push(
          ...this.markAndCollectMissingRequired(child, [...path, key])
        );
      });
    } else if (control instanceof FormArray) {
      control.controls.forEach((child, index) => {
        missing.push(
          ...this.markAndCollectMissingRequired(child, [...path, String(index)])
        );
      });
    } else if (control instanceof FormControl) {
      control.markAsTouched({ onlySelf: true });
      control.updateValueAndValidity({ onlySelf: true });
      if (control.errors?.['required']) {
        // Use the joined path as field identifier
        missing.push(path.join('.'));
      }
    } else {
      // Generic AbstractControl fallback
      control.markAsTouched();
      control.updateValueAndValidity();
    }
    return missing;
  }

  // Try to focus and scroll to the first invalid control in the main form
  private focusFirstInvalidControl(): void {
    try {
      // Use attribute selector to find the first invalid control
      const invalid: HTMLElement = document.querySelector(
        'form .ng-invalid[formcontrolname]'
      ) as HTMLElement;
      if (invalid && typeof invalid.focus === 'function') {
        invalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        invalid.focus();
      }
    } catch (e) {
      // no-op
    }
  }

  // Optional: map technical control names to user-friendly labels
  private labelFor(controlPath: string): string {
    const base = controlPath.split('.')[0];
    const map: Record<string, string> = {
      name: 'Contact Name',
      userName: 'Contact Name',
      email: 'Email',
      affiliatedBy: 'Affiliation',
      contactNo: 'Contact Number',
      faithName: 'Faith',
      faith: 'Faith',
      address: 'Address',
      website: 'Website',
      shortBio: 'Short Bio',
      businessUserName: 'User Name',
      phonecode: 'Phone Code',
      category: 'Category',
      menu: 'Menu',
    };
    return map[base] || base;
  }

  public onSubmit(values: Object): void {
    console.log(this.form.value.faithName, 'this.form', this.selectedFaith);
    let userObj = {};
    this.submitted = true;

    // Hard guard: location (lat/long) must be present
    const loc = this.form.get('location')?.value;
    if (!(loc?.coordinates && loc.coordinates.length === 2)) {
      Swal.fire('Error', 'Please use Google location (pick from suggestions).');
      return;
    }

    if (this.form.invalid) {
      // Mark all controls as touched so template shows red borders (ng-invalid + ng-touched)
      const missingRequired = this.markAndCollectMissingRequired(this.form);
      console.warn('Missing required fields:', missingRequired);
      const prettyList = missingRequired.map((n) => this.labelFor(n));
      const uniqueList = Array.from(new Set(prettyList)).filter(Boolean);
      const message = uniqueList.length
        ? 'Please complete the following required fields: \n\n• ' + uniqueList.join('\n• ')
        : 'Please complete all required fields.';
      Swal.fire('Missing Information', message, 'error');
      // Scroll/focus first invalid control to guide the user
      setTimeout(() => this.focusFirstInvalidControl());
      return;
    }

    if (!this.form?.value?.faithName) {
      this.form.controls['faithName'].setValue('');
      Swal.fire('Error', 'Faith name is required.', 'error');
      return;
    }

    let phonecode = this.form.get('phonecode').value;
    let contactNo = this.form.get('contactNo').value;
    let isUrl = this.isValidUrl(values['website']);

    if (!this.isChecked) {
      Swal.fire(
        'Error',
        'Please select our terms of services and privacy policy to continue.',
        'error'
      );
      return;
    }

    if (contactNo && !phonecode) {
      Swal.fire('Error', 'Phone code is required', 'error');
      return;
    }

    if (this.businessIds.length == 0) {
      Swal.fire('Error', 'Business Type is required', 'error');
      return;
    }

    let phoneNumber = phonecode + contactNo;
    userObj['photo'] = this.profilePic;
    userObj['coverPhoto'] = this.coverPhoto;
    userObj['phonecode'] = phonecode;
    userObj['contactNo'] = contactNo;
    //userObj['userName'] = this.form.get('userName').value;
    userObj['name'] = this.form.get('name').value;
    userObj['affiliatedBy'] = this.affiliatedId;
    userObj['faith'] = this.selectedFaith;
    userObj['subFaith'] = this.selectedFaith2;
    userObj['subFaith2'] = this.selectedFaith3;
    userObj['logLine'] = this.form.get('logLine').value;
    userObj['bussinessTypes'] = this.businessIds;
    userObj['location'] = this.address['location'];
    userObj['website'] = this.form.get('website').value;
    userObj['address'] = this.address;
    userObj['address2'] = this.form.get('address2').value;
    userObj['menu'] = this.form.get('menu').value;
    userObj['customCategory'] = this.form.get('category').value;
    userObj['isBusinessContactNameVisible'] = this.isBusinessContactNameVisible;
    userObj['showStreetAddress'] = this.isShowStreetAddress;
    userObj['shortBio'] = this.form.get('shortBio').value;
    //userObj['email'] = this.form.get('email').value;
    userObj['subscriptionPlanType'] = this.subscriptionPlanId;
    userObj['businessUserName'] = this.form.get('businessUserName').value;
    // App Store Links
    userObj['iosAppLink'] = this.form.get('iosAppStoreLink').value;
    userObj['androidAppLink'] = this.form.get('androidAppStoreLink').value;
    // Social Profile Links
    userObj['socialProfileLinks'] = {
      facebook: this.form.get('facebookLink').value || '',
      instagram: this.form.get('instagramLink').value || '',
      youtube: this.form.get('youtubeLink').value || '',
      linkedin: this.form.get('linkedinLink').value || '',
      tiktok: this.form.get('tiktokLink').value || ''
    };
    this.updateProfile(userObj);
  }

  public getUserProfile(): void {
    this.ngxService.start();
    this.authenticationService.getProfile().subscribe(
      (response: any) => {
        this.userData = response.data;
        this.getProfileData(this.userData);
        // Swal.fire();
        this.ngxService.stop();
      },
      (error) => {
        this.ngxService.stop();
        if (error.error.message == 'Unauthorized') {
          this.router.navigateByUrl('/login');
        }
      }
    );
  }
  openFaithValue() {}
  getProfileData(user?: any) {
    if (!user) {
      console.warn("No user data provided to getProfileData()");
      return;
    }
    
    // Basic user info
    this.form.controls['name'].setValue(user?.name || '');
    this.form.controls['userName'].setValue(user?.userName || '');
  
    this.faithId = user?.faith?._id || '';
    this.form.controls['faithName'].setValue(user?.faith?.name || '');
    this.form.controls['subfaithName'].setValue(user?.subFaith?.name || '');
    this.form.controls['subfaith2Name'].setValue(user?.subFaith2?.name || '');
  
    // Faith controls: set IDs to match ng-select bindValue="_id"
    this.form.controls['faith'].setValue(user?.faith?._id || '');
    this.form.controls['faith2'].setValue(user?.subFaith?._id || '');
    this.form.controls['faith3'].setValue(user?.subFaith2?._id || '');
    this.form.controls['logLine'].setValue(user?.logLine || '');
  
    // Email fallback logic
    const emailVal =
      user?.email ||
      user?.user?.email ||
      user?.contactEmail ||
      user?.businessEmail ||
      '';
    this.form.controls['email'].setValue(emailVal);
  
    // Additional fields
    this.form.controls['shortBio'].setValue(user?.shortBio || '');
    this.form.controls['website'].setValue(user?.website || '');
    this.form.controls['address2'].setValue(user?.address2 || '');
    this.form.controls['contactNo'].setValue(user?.contactNo || '');
    this.form.controls['phonecode'].setValue(user?.phonecode || '');
    this.form.controls['menu'].setValue(user?.menu || '');
  
    // Address
    const address = user?.address || {};
    this.form.controls['address'].setValue(address?.googleAddress || '');
  
    console.log("Form after user data patch:", this.form.value);
  
    // Location if present
    if (address?.location) {
      this.form.controls['location'].setValue(address.location);
    }
  
    // Default subscription type
    this.form.controls['subscriptionPlanType'].setValue('1');
    this.form.controls['businessUserName'].setValue(user?.businessUserName || '');
    
    // App Store Links
    this.form.controls['iosAppStoreLink'].setValue(user?.iosAppLink || '');
    this.form.controls['androidAppStoreLink'].setValue(user?.androidAppLink || '');
    
    // Social Profile Links
    const socialProfileLinks = user?.socialProfileLinks || {};
    this.form.controls['facebookLink'].setValue(socialProfileLinks?.facebook || '');
    this.form.controls['instagramLink'].setValue(socialProfileLinks?.instagram || '');
    this.form.controls['youtubeLink'].setValue(socialProfileLinks?.youtube || '');
    this.form.controls['linkedinLink'].setValue(socialProfileLinks?.linkedin || '');
    this.form.controls['tiktokLink'].setValue(socialProfileLinks?.tiktok || '');
  
    this.businessUserName = user?.businessUserName || '';
  
    this.selectedFaith = user?.faith?._id || '';
    this.selectedFaith2 = user?.subFaith?._id || '';
    this.selectedFaith3 = user?.subFaith2?._id || '';
  
    // Business Hours
    if (user?.bussinessHours) {
      this.getBusinessHour(user.bussinessHours);
      this.getBusinessHours(user.bussinessHours);
    }
  
    this.isBusinessContactNameVisible = user?.isBusinessContactNameVisible || false;
    this.isShowStreetAddress = user?.showStreetAddress || false;
  
    this.address = address;
  
    // Affiliation
    let updatedAffiliationData = localStorage.getItem('affiliationData');
    if (updatedAffiliationData) {
      const data = JSON.parse(updatedAffiliationData);
      this.affiliatedId = data?._id || '';
      this.form.controls['affiliatedBy'].setValue(data?.name || '');
    } else if (user?.affliatedBy) {
      this.affiliatedId = user?.affliatedBy?.id || '';
      this.form.controls['affiliatedBy'].setValue(user?.affliatedBy?.name || '');
    }
  
    // Photos
    this.form.controls['photo'].setValue(user?.photo || '');
    this.form.controls['coverPhoto'].setValue(user?.coverPhoto || '');
    this.profilePic = user?.photo || '';
    this.coverPhoto = user?.coverPhoto || '';
  
    // Address main form group (ensure it exists)
    if (this.addressMain && address) {
      this.addressMain.controls['googleAddress'].setValue(address?.googleAddress || '');
      this.addressMain.controls['city'].setValue(address?.city || '');
      this.addressMain.controls['state'].setValue(address?.state || '');
      this.addressMain.controls['streetAddress'].setValue(address?.streetAddress || '');
      this.addressMain.controls['postalCode'].setValue(address?.postalCode || '');
      this.addressMain.controls['country'].setValue(address?.country || '');
      this.addressMain.controls['address_contact_no'].setValue(address?.address_contact_no || '');
      this.addressMain.controls['location'].setValue(address?.location || '');
      this.addressMain.controls['suite_no'].setValue(address?.suite_no || '');
    }
  
    // Business types
    this.businessIds = [];
    this.bussiness = [];
    const businessType = user?.bussinessTypes || [];
  
    if (Array.isArray(businessType) && businessType.length > 0) {
      businessType.forEach(item => {
        const cat = item?.categoryId?._id || item?.categoryId || null;
        const tagId = item?.tagId?._id || item?.tagId || null;
        const tagName = item?.tagName || item?.tag?.name || item?.name || '';
        if (tagName) {
          this.selectBusinessType(cat, tagId, tagName);
        }
      });
    }
  
    // Custom categories
    const custCategories = user?.customCategory || [];
    const custObj: any = {};
    this.valueAndFaith = user?.menu || '';
  
    if (custCategories[0]?.description) this.isDescription = false;
    if (custCategories?.length >= 3) this.checkLabel = true;
  
    custCategories.forEach(c => {
      custObj['title'] = c?.title || '';
      custObj['description'] = c?.description || '';
      this.custCat(custObj);
    });
  }
  
  addArr(obj) {
    this.addresses = this.form.get('addresses') as FormArray;

    this.addresses.push(
      this.fb.group({
        streetAddress: obj.streetAddress,
        suite_no: obj.suite_no,
        city: obj.city,
        location: obj.location,
        state: obj.state,
        googleAddress: obj.googleAddress,
        postalCode: obj.postalCode,
        country: obj.country,
        address_contact_no: obj.address_contact_no,
        address_alternateContact_no: obj.address_alternateContact_no,
      })
    );
  }
  custCat(obj) {
    // this.category.removeAt(0);
    this.category = this.form.get('category') as FormArray;
    this.category.push(
      this.fb.group({
        title: obj.title,
        description: obj.description,
      })
    );

    // this.category.removeAt(0);
    // this.category = this.form.get('category') as FormArray;
    // if(!this.category[0].title && !this.category[0].description) {
    //   this.category.clear();
    // }
    // this.category.push(this.fb.group({
    //   title: obj.title,
    //   description: obj.description,
    // }));
    // this.category.removeAt(0);
  }

  getBusinessHour(record: any) {
    if (record && record?.Sunday.length > 0) {
      this.Sunday = this.formBusiness?.get('Sunday') as FormArray;
      this.Sunday.clear();
      for (let i = 0; i < record.Sunday?.length; i++) {
        this.Sunday.push(
          this.fb.group({
            Start: record?.Sunday[i].Start,
            Finish: record?.Sunday[i].Finish,
          })
        );
      }
    }
    if (record && record?.Monday?.length > 0) {
      this.Monday = this.formBusiness.get('Monday') as FormArray;
      this.Monday.clear();
      for (let i = 0; i < record?.Monday?.length; i++) {
        this.Monday.push(
          this.fb.group({
            Start: record?.Monday[i].Start,
            Finish: record?.Monday[i].Finish,
          })
        );
      }
    }
    if (record && record?.Tuesday?.length > 0) {
      this.Tuesday = this.formBusiness?.get('Tuesday') as FormArray;
      this.Tuesday.clear();
      for (let i = 0; i < record.Tuesday?.length; i++) {
        this.Tuesday.push(
          this.fb.group({
            Start: record.Tuesday[i]?.Start,
            Finish: record.Tuesday[i]?.Finish,
          })
        );
      }
    }
    if (record && record.Wednesday?.length > 0) {
      this.Wednesday = this.formBusiness?.get('Wednesday') as FormArray;
      this.Wednesday.clear();
      for (let i = 0; i < record.Wednesday?.length; i++) {
        this.Wednesday.push(
          this.fb.group({
            Start: record.Wednesday[i]?.Start,
            Finish: record.Wednesday[i]?.Finish,
          })
        );
      }
    }
    if (record && record.Thursday?.length > 0) {
      this.Thursday = this.formBusiness.get('Thursday') as FormArray;
      this.Thursday.clear();
      for (let i = 0; i < record.Thursday?.length; i++) {
        this.Thursday.push(
          this.fb.group({
            Start: record.Thursday[i].Start,
            Finish: record.Thursday[i].Finish,
          })
        );
      }
    }
    if (record && record.Friday?.length > 0) {
      this.Friday = this.formBusiness.get('Friday') as FormArray;
      this.Friday.clear();
      for (let i = 0; i < record.Friday?.length; i++) {
        this.Friday.push(
          this.fb.group({
            Start: record.Friday[i]?.Start,
            Finish: record.Friday[i]?.Finish,
          })
        );
      }
    }
    if (record && record.Saturday?.length > 0) {
      this.Saturday = this.formBusiness?.get('Saturday') as FormArray;
      this.Saturday.clear();
      for (let i = 0; i < record.Saturday?.length; i++) {
        this.Saturday.push(
          this.fb.group({
            Start: record.Saturday[i]?.Start,
            Finish: record.Saturday[i]?.Finish,
          })
        );
      }
    }
  }
 updateProfile(userData: any) {
  this.ngxService.start();
  
  this.authenticationService.updateProfile(userData).subscribe({
    next: (response: any) => {
      this.ngxService.stop();
      const user = response?.data;
      if (user?.token) {
        // Update localStorage
        // localStorage.setItem('merchant_token', user.token);
        localStorage.setItem('name', user.name);
        localStorage.setItem('planType', user.subscriptionPlanType);
        localStorage.setItem('merchant_currentUser1', JSON.stringify(user));

        this.messageService.setValue(user.name);
        this.authenticationService.getUserInfo(response);

        Swal.fire({
          title: 'Congratulations',
          html: `Your profile has been updated.`,
          allowOutsideClick: false,
          width: '400px',
        }).then(() => {
          localStorage.removeItem('affiliationData');
          this.router.navigate(['/dashboard']);
        });

      } else if (response?.code === 200) {
        Swal.fire({
          title: 'Congratulations',
          html: `Your profile has been updated.`,
          allowOutsideClick: false,
          width: '400px',
        }).then(() => {
          localStorage.removeItem('affiliationData');
          this.router.navigate(['/dashboard']);
        });
      }
    },

    error: (error) => {
      this.ngxService.stop();
      console.error('Profile update error:', error);

      const errorMessage =
        error?.error?.message || 'An unexpected error occurred while updating the profile.';
      Swal.fire('Error', errorMessage, 'error');

      if (error.status === 401) {
        // Optionally handle unauthorized access
        // localStorage.removeItem("merchant_currentUser1");
      }
    },

    complete: () => {
      this.ngxService.stop();
    },
  });
}

  redirectTo() {
    if (this.user.isFirstUpdateDone) {
      this.router.navigateByUrl('/dashboard');
    } else {
      this.router.navigateByUrl('/login');
    }
  }

  checkImage(usr) {
    if (usr) {
      let pathArray = usr.split('/');
      let protocol = pathArray[0];
      let host = pathArray[2];
      let url = protocol + '//' + host + '/';
      if (
        url == environment.basePath &&
        (protocol == 'https:' || protocol == 'http:')
      ) {
        return usr;
      } else if (protocol == 'uploads') {
        return environment.basePath + usr;
      } else {
        return usr;
      }
    }
  }
  public getMerchantProfile(id): void {
    this.authenticationService.getMerchantById(id).subscribe(
      (data: any) => {
        let user = data['data'];
        if (user.isFirstUpdateDone == true && user.isEmailVarified == true) {
          this.router.navigate(['/dashboard']);
          Swal.fire('', 'User is logged in sucessfully.', 'success');
        } else if (
          user.isFirstUpdateDone == true &&
          user.isEmailVarified == false
        ) {
          this.router.navigate(['/email-verification']);
        }
      },
      (error) => {
        if (error) {
          Swal.fire('Oops...', error.error.message, 'error');
        }
      }
    );
  }
  checkCheckBoxvalue(event) {
    this.isChecked = event.target.checked;
  }

  getSubscription(event: any, content: any) {
    this.subscriptionPlanId = event._id;
    this.selectedPlan = event;
    setTimeout(() => {
      this.modalService.open(content, { size: 'sm' });
    }, 500);
  }

  getSubscriptionPlanType() {
    this.authenticationService.getPlan(true).subscribe((res: any) => {
      res.data.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
      this.subscriptionPlans = res?.['data'];
    });
  }

  openFullscreen(content: any) {
    window.scrollTo(0, 0);
    this.modalService.open(content, { size: 'xl', scrollable: true });
  }

  editLabel() {
    if (this.isEdit == false) {
      this.isEdit = true;
    } else {
      this.isEdit = false;
    }
  }

  convertSubscripitonType(days: number) {
    if (days === 365) {
      return 'Yearly';
    } else if (days === 30) {
      return 'Monthly';
    } else if (days === 90) {
      return 'Quarterly';
    } else if (days === 180) {
      return 'Half Yearly';
    }
    return 'Days';
  }

  onInputChange(event: any) {
    // if(event.target.value)  this.bussinessList = this.getFilteredRecord(event.target.value)
    // else this.bussinessList = this.newBussinessListData;
    // console.log(this.bussinessList, 'this.bussinessList')
    this.businessList(event.target.value);
    // this.bussinessList = this.newBussinessListData.filter((val) =>
    //   val.category.toLowerCase().includes(event.target.value.toLowerCase())
    // );
  }

  changeFaith(event: any) {
    // event may be an id (string) due to bindValue or the full object
    const selected = typeof event === 'string'
      ? this.faithList.find((item: any) => item._id === event)
      : event;

    if (!selected) {
      return;
    }

    this.form.controls['faithName'].setValue(selected.name || '');
    this.form.controls['subfaithName'].setValue('');
    this.form.controls['subfaith2Name'].setValue('');
    this.selectedFaith2 = '';
    this.selectedFaith3 = '';
    const filteredFaith = this.faithList.find(
      (item: any) => item._id == (selected?._id)
    );
    this.faithListLevel2 = filteredFaith?.subcategory || [];
  }

  changeSubFaith(event: any) {
    const selected = typeof event === 'string'
      ? this.faithListLevel2.find((item: any) => item._id === event)
      : event;

    if (!selected) {
      return;
    }

    this.form.controls['subfaithName'].setValue(selected.name || '');
    const filteredFaith = this.faithListLevel2.find(
      (item: any) => item._id == (selected?._id)
    );
    this.faithListLevel3 = filteredFaith?.subcategory || [];
  }
  changeSubFaith2(event: any) {
    const selected = typeof event === 'string'
      ? this.faithListLevel3.find((item: any) => item._id === event)
      : event;

    if (!selected) {
      return;
    }

    this.form.controls['subfaith2Name'].setValue(selected.name || '');
  }


  onNameSelected(event: any): void {
    console.log('Received address event:', event);

    // Assuming the event provides all necessary address components
    if (event) {
      this.ministryAddress = {
        address2: event?.address_components?.[1]?.long_name || '',
        formatted_address: event?.formatted_address || '',
        location: {
          type: 'Point',
          coordinates: [
            event?.geometry?.location?.lng() || 0, // longitude
            event?.geometry?.location?.lat() || 0  // latitude
          ]
        },
        isHidePhone: false  // or set based on your form or logic
      };

      // Optionally, update the form if needed
      this.ministrySuggestionForm.patchValue({
        formattedAddress: event?.formatted_address
      });
      this.ministrySuggestionForm.controls['name'].setValue(event.name);
    }
  }



}
